export default __webpack_public_path__ + "static/media/star.823c88ce.png";